/* 🤖 this file was generated by script */
export const wiconPipedrive = {
  name: 'pipedrive',
  data: `<svg viewBox="0 0 20 20"><path fill="currentColor" d="M17 18l-4.26-1.67H4.72c-.95 0-1.72-.82-1.72-1.82V3.82C3 2.82 3.77 2 4.72 2h10.56c.95 0 1.72.82 1.72 1.82V18zm-2.07-7.29a.44.44 0 00-.65-.05c-.01.01-1.5 1.34-4.28 1.34a6.78 6.78 0 01-4.29-1.34.44.44 0 00-.64.05c-.18.23-.18.78.05.98A7.52 7.52 0 0010 13.27a7.52 7.52 0 004.88-1.58c.27-.24.26-.72.05-.98z"/></svg>`,
};
